import Vue from 'vue';

const formProto = {
  name: "",
  status: "idle",
  original: {},
  fields: {},
  errors: {},
  disabled: {},
};

/**
 * createForm initializes a form by name in the store.
 */
export const createForm = (state, { name, fields }) => {
  const newForm = {
    ...formProto,
    name,
    original: { ...fields },
    fields: { ...fields }
  };

  state.forms.push(newForm);
};

/**
 * deleteForm completely removes a form from the store state.
 */
export const deleteForm = (state, index) => {
  state.forms.splice(index, 1);
};

/**
 * setStatus sets the current string state of the form.
 */
export const setStatus = (state, { index, status }) => {
  state.forms[index].status = status;
};

/**
 * setField changes the value of a field in the vuex store.
 */
export const setField = (state, { index, field, value }) => {
  _.set(state.forms[index].fields, field, value);
};

/**
 * setErrors mutates the store to contain the given object of errors.
 */
export const setErrors = (state, { index, errors }) => {
  state.forms[index].errors = errors;
};

/**
 * setDisabled sets a custom disabled flag on the given field
 */
export const setDisabled = (state, { index, field, value }) => {
  Vue.set(state.forms[index].disabled, field, value);
};
